export const numberFormatCompact = (unformattedNumber) => {
    return new Intl.NumberFormat('en-US', { notation: 'compact' }).format(unformattedNumber);
};
